import { observable, action, runInAction } from "mobx";

import { Api, CommonsStore, LoggerFactory } from "../index";

export interface AuthStoreInterface {
  isLoading: boolean;
  currentUser: User | undefined;
  logout: () => void;
  getCurrentUser: () => void;
}

export interface User {
  roles: string[];
  username: string;
}

const log = LoggerFactory.create("AuthStore");

class AuthStore implements AuthStoreInterface {
  public static CURRENT_USER_KEY = "CURRENT_USER";

  @observable public username: string;
  @observable public isLoading: boolean;
  @observable public currentUser: User | undefined;
  // @ts-ignore
  @observable private syncIsLoggedIn: boolean;

  private api: Api;
  private commons: CommonsStore;

  constructor(api: Api, commons: CommonsStore) {
    this.api = api;
    this.isLoading = false;
    this.syncIsLoggedIn = false;
    this.username = this.currentUser ? this.currentUser.username : "";
    this.commons = commons;
  }

  @action("logout")
  public async logout() {
    try {
      this.currentUser = undefined;
      this.commons.trigger("auth.logout");
    } catch (error) {
      runInAction(() => {
        const errorMessage = "logout failed";
        log.error(errorMessage);
      });
    }
  }

  @action("load current user")
  public getCurrentUser(): void {
    this.api
      .getOne(`auth/me`)
      .then((resp: any) => {
        runInAction(() => {
          this.currentUser = resp;
        });
      })
      .catch((error: any) => {});
  }
}

export { AuthStore };
